import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { inject, observer } from "mobx-react";

import {
    Toolbar,
    Typography,
    Tooltip,
    Dialog,
    Button,
    DialogTitle,
    DialogContent,
    Grid,
    TextField,
    DialogContentText,
    DialogActions
} from "@material-ui/core";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckIcon from "@material-ui/icons/Check";

import green from "@material-ui/core/colors/green";
import Slide from "@material-ui/core/Slide";

@inject("designProfileStore", "stateStore", "regionStore", "organisationStore", "templateStore")
@observer
class RegionTableToolbar extends React.Component {
    state = {
        newName: "",
        newSuburb: "",
        newState: "",
        openAdd: false,
        openDelete: false,
        openDialog: false,
        success: false
    };

    lastData = [];

    handleNameChange = e => this.props.regionStore.setName(e.target.value);
    handleAddressChange = e => this.props.regionStore.setAddress(e.target.value);
    handleContactNumberChange = e => this.props.regionStore.setContactNumber(e.target.value.replace(/\D/,''));

    handleSubmitClick = () => {
        this.props.regionStore.create();
        this.props.templateStore.closeStateBlock();
        this.handleCloseDialog();
    };

    handleDeleteClick = () => {
        this.props.selected.map(om => {
            return this.props.regionStore.remove(om);
        });
        this.props.handleClearSelected();
        this.props.templateStore.closeStateBlock();
        this.setState({ openDelete: true });

        return true;
    };

    handleSnackbarAddOpen = () => {
        this.setState({ openAdd: true });
    };

    handleSnackbarAddClose = (event, reason) => {
        this.setState({ openAdd: false });
        if (reason === "undo") {
            //execute undo add
            this.props.designProfileStore.deletePlayedAt(this.lastData);
        }
    };

    handleSnackbarDeleteOpen = () => {
        this.setState({ openDelete: true });
    };

    handleSnackbarDeleteClose = (event, reason) => {
        this.setState({ openDelete: false });
        if (reason === "undo") {
            this.props.designProfileStore.addPlayedAt(this.lastData);
        }
    };

    handleOpenDialog = () => {
        this.props.regionStore.resetAddForm();
        this.setState({ openDialog: true });
    };

    handleCloseDialog = () => {
        this.setState({ openDialog: false });
    };

    transition = props => {
        return <Slide direction="up" {...props} />;
    };

    render() {
        const { classes, selected } = this.props;
        const { playedAtSuccess } = this.props.designProfileStore;
        const fullScreen = false;
        const { canManage } = this.props.stateStore;
        const { name, address, contactNumber } = this.props.regionStore;
        const { level2Label, level3Label } = this.props.organisationStore;
        let numSelected = selected.length;

        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0
                })}
            >
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography variant="subheading" style={{ color: "#FFF" }}>
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Typography variant="subheading">{level3Label}</Typography>
                    )}
                </div>
                <div className={classes.spacer} />
                {canManage ? (
                    <div className={classes.actions}>
                        {numSelected > 0 ? (
                            <Tooltip title="Delete">
                                <Button aria-label="Delete" style={{ color: "#FFF" }} onClick={this.handleDeleteClick}>
                                    <DeleteIcon />
                                    <span className={classes.textSideIcon}>Delete </span>
                                </Button>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Add">
                                <Button
                                    id="add-region"
                                    aria-label="Add"
                                    onClick={this.handleOpenDialog}
                                    style={playedAtSuccess ? { color: green[800] } : null}
                                >
                                    {playedAtSuccess ? (
                                        <CheckIcon />
                                    ) : (
                                        <React.Fragment>
                                            <AddIcon style={{color:"white"}}/>
                                            <span className={classes.textSideIcon} style={{color:"white"}}>Add</span>
                                        </React.Fragment>
                                    )}
                                </Button>
                            </Tooltip>
                        )}
                    </div>
                ) : (
                    ""
                )}
                {canManage ? (
                    <Dialog fullScreen={fullScreen} open={this.state.openDialog} onClose={this.handleCloseDialog} transition={this.transition}>
                        <DialogTitle className="see-more-dialog-title">Add {level3Label}</DialogTitle>
                        <DialogContent className="see-more-dialog-content">
                            <div style={{ padding: 16 }}>
                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <DialogContentText className={classes.blackTextColor}>
                                            Add new {level3Label} to your {level2Label}
                                        </DialogContentText>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        <TextField
                                            id="region-name"
                                            autoFocus={true}
                                            placeholder={level3Label + " name"}
                                            label="Name"
                                            margin="none"
                                            fullWidth
                                            value={name}
                                            onChange={this.handleNameChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="region-contactNumber"
                                            placeholder="Phone or mobile number"
                                            label="Contact Number"
                                            margin="none"
                                            fullWidth
                                            value={contactNumber}
                                            onChange={this.handleContactNumberChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            id="region-address"
                                            placeholder="Address"
                                            label="Address"
                                            margin="none"
                                            fullWidth
                                            value={address}
                                            onChange={this.handleAddressChange}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDialog} color="primary">
                                Close
                            </Button>
                            <Button onClick={this.handleSubmitClick} color="primary" id="region-submit">
                                Add {level3Label}
                            </Button>
                        </DialogActions>
                    </Dialog>
                ) : (
                    ""
                )}
            </Toolbar>
        );
    }
}

RegionTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    selected: PropTypes.array.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
        backgroundColor: "#ff0c9c"
    },
    highlight: {
        backgroundColor: "#333333"
    },
    spacer: {
        flex: "1 1 100%"
    },
    actions: {
        color: theme.palette.text.secondary
    },
    title: {
        flex: "0 0 auto"
    },
    blackTextColor: {
        color: "#000"
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: 2,
        right: 2,
        zIndex: 1
    },
    textSideIcon: {
        paddingTop: 3
    }
});

export default withMobileDialog()(withStyles(toolbarStyles)(RegionTableToolbar));
